import {UNI_VERSION} from "@/lib/version";

export const baseParams = {
  channel: "3", format: "JSON", oper: "127.0.0.1", spid: "1001", version: UNI_VERSION
}

export const password = "aAr9MVS9j1";



// WEBPACK FOOTER //
// ./src/lib/baseConfig.js